module.exports = __webpack_public_path__ + "img/planting-tree-mb.729026b5.jpg";